import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {switchMap, tap} from "rxjs/operators";
import {Page, Pageable} from "../../../model/rest/base";
import {TeacherV3RestService} from "../../../services/rest/v3/teacher-rest.service";
import {TeacherStats, V3School} from "../../../model/v3/schools";

@Component({
    selector: 'app-teachers-summary-block',
    templateUrl: './teachers-summary-block.component.html',
    styleUrls: ['./teachers-summary-block.component.css'],
    standalone: false
})
export class TeachersSummaryBlockComponent implements OnInit {
  mSchool: V3School;
  private teachersTotal: number;
  private ready = false;
  private stats: TeacherStats;

  @Input()
  set school(value: V3School) {
    this.mSchool = value;
    this.reload();
  }
  @Output() redirectEmitter: EventEmitter<string> = new EventEmitter();

  constructor(private teacherV3Rest: TeacherV3RestService) { }

  ngOnInit() {
  }

  private reload() {
    if (!this.mSchool) return;
    this.ready = false;
    this.loadTeachers(this.mSchool.id)
      .pipe(
        tap(page => this.store(page)),
        switchMap( _ => this.loadTeachersStats(this.mSchool.id)),
        tap( stats => this.stats = stats)
      )
      .subscribe();
  }

  private loadTeachersStats(schoolId: number) {
    return this.teacherV3Rest.countTeacherStats(schoolId);
  }

  private loadTeachers(schoolId: number) {
    return this.teacherV3Rest.findTeachers(schoolId, null, null, Pageable.of(0,1, null));
  }

  private store(page: Page<any>) {
    this.ready = true;
    this.teachersTotal = page.totalElements;
  }

  isReady() {
    return this.ready;
  }

  getTeachersNumber() {
    return this.teachersTotal;
  }

  hasAnyStats() {
    return this.stats &&
      (this.getNew() || this.getActivated() || this.getBlocked() || this.getUpdated() || this.getDeleted())
  }

  getNew() {
    return this.stats.new;
  }

  getActivated() {
    return this.stats.activations;
  }

  getBlocked() {
    return this.stats.deactivations;
  }

  getUpdated() {
    return this.stats.updates;
  }

  getDeleted() {
    return this.stats.deletions;
  }

  redirectTo(path: string) {
    this.redirectEmitter.emit(path);
  }
}
